module.exports = "<div class=app-container> <div class=app-content> <router-view></router-view> </div> <common-component v-ref:common-component></common-component> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/appBackend/app/app.tpl
// module id = 862
// module chunks = 2